import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-co-right-down",
  "use": "icon-co-right-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-corner-right-down\" id=\"icon-co-right-down\"><polyline points=\"10 15 15 20 20 15\" /><path d=\"M4 4h7a4 4 0 0 1 4 4v12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol